import { render, staticRenderFns } from "./DetalleNotificacion.vue?vue&type=template&id=2b64e45f&"
import script from "./DetalleNotificacion.vue?vue&type=script&lang=ts&"
export * from "./DetalleNotificacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b64e45f', component.options)
    } else {
      api.reload('2b64e45f', component.options)
    }
    module.hot.accept("./DetalleNotificacion.vue?vue&type=template&id=2b64e45f&", function () {
      api.rerender('2b64e45f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/DetalleNotificacion.vue"
export default component.exports